export enum Sounds {
    CAMERA = 'camera.wav',
    DOOR_LOCK = 'doorlock.wav',
    LAZER = 'lazer.wav',
    LAZER_SLOW = 'lazer_slow.wav',
    SWITCH = 's_switch.wav',
    SLIDE = 'slide.wav',
    TICK = 'tick.wav',
    ZAP = 'zap.wav'
}
